/* eslint-disable */
export default {
    name: 'editorSettings',
    theWorksInline() {
        return {
            selector: '.tinymce_content',
            browser_spellcheck: true,
            branding: false,
            sticky_offset: 300,
            plugins: ["image", "link", "code", "paste", "table", "lists"],
            inline: true,
            toolbar: ["undo redo cut copy paste bold italic underline numlist bullist | alignleft alignright aligncenter | styleselect | image link unlink code "],
            toolbar_persist: true,
            image_advtab: false,
            image_class_list: [
                {title: 'Image Left', value: 'gp-user-image-left'},
                {title: 'Image Right', value: 'gp-user-image-right'},
                {title: 'Image Center', value: 'gp-user-image-center'},
                {title: 'None', value: 'gp-user-image'}
            ],
            style_formats_merge: true,
            paste_as_text: true,
            relative_urls: false,
            keep_styles: false,
            remove_script_host: false,
            table_responsive_width: true,
            table_default_attributes: {
                class: "table table-responsive table-bordered table-striped table-hover",
                style: ""
            },
            height: 400,
            formats: {
                bold: [
                    {inline: 'span', classes: 'gp-user-text-bold'},
                ],
                font25: {selector: 'p,div,span', classes: 'gp-user-text-125', attributes: {title: "Larger Font"}},
                font50: {selector: 'p,div,span', classes: 'gp-user-text-150', attributes: {title: "Larger Font x2"}},
                font2x: {selector: 'p,div,span', classes: 'gp-user-text-2x', attributes: {title: "Double large font"}},
                font3x: {selector: 'p,div,span', classes: 'gp-user-text-3x', attributes: {title: "Triple large font"}},
            },
            style_formats: [
                {title: "Font +25%", format: 'font25'},
                {title: "Font +50%", format: 'font50'},
                {title: "Font 2x", format: 'font2x'},
                {title: "Font 3x", format: 'font3x'},
                {
                    title: 'Info Color',
                    inline: 'span',
                    classes: 'text-info'
                },
                {
                    title: 'Legal Explanation',
                    block: 'span',
                    classes: 'text-info small mb-2'
                },
                {
                    title: 'Warning',
                    inline: 'span',
                    classes: 'text-warning'
                },
                {
                    title: 'Danger',
                    inline: 'span',
                    classes: 'text-danger'
                },
                {
                    title: 'Success',
                    inline: 'span',
                    classes: 'text-success'
                }
            ],
            setup: function (editor) {
                editor.on("nodeChange", function (e) {
                    if (e.element.tagName === "IMG") {
                        if (e.element.classList.contains("gp-user-image-left") || e.element.classList.contains("gp-user-image-right")) {
                            let content = editor.getContent();
                            if (content) {
                                let loc = content.indexOf("gp-end-wrap");
                                if (loc < 0) {
                                    content += "<p>&nbsp;</p><p>&nbsp;</p><div class=\"gp-end-wrap\">&nbsp;</div>";
                                    editor.setContent(content);
                                }
                            }
                        }
                    }
                });
            }
        };
    }
};
